// Gemeinsame Suchfilter für Auswahllisten (#251, #255).
//
// Vorher stand dieselbe Bedingung sechsmal in den Komponenten (Mail, Mail-Detail,
// Teams, Termin, Zusammenführen, Seitenleiste) und suchte nur Ticketnummer und
// Titel. Der Kunde stand auf der Karte direkt darüber, ließ sich aber nicht
// finden. Sechs Kopien derselben Regel sind die Drift, die bei „Weiteren
// erstellen“ schon einmal passiert ist (#158/#230) -- deshalb eine Stelle.
//
// Regel: Der Suchbegriff wird an Leerzeichen in Wörter zerlegt, und JEDES Wort
// muss in irgendeinem der Felder vorkommen (Groß-/Kleinschreibung egal). Ein
// einzelnes Wort verhält sich damit genau wie vorher; „Müller Drucker“ findet
// jetzt das Drucker-Ticket von Kunde Müller. Alles, was vorher gefunden wurde,
// wird weiterhin gefunden.

function woerter(begriff) {
  return String(begriff || '').toLowerCase().split(/\s+/).filter(Boolean);
}

// #255: Telefonnummern stehen in allen Schreibweisen im Stamm („0621 123 45“,
// „0621/12345“). Ein Wort, das wie eine Nummer aussieht (nur Ziffern und
// + - / ( ), mindestens vier Ziffern), passt deshalb auch, wenn seine Ziffern in
// den Ziffern eines Feldes stehen -- „062112345“ findet „0621 123 45“.
const NUMMERNARTIG = /^[+\d][\d()/-]*$/;
function nurZiffern(text) {
  return String(text).replace(/\D/g, '');
}
function wortPasst(wort, texte) {
  if (texte.some(text => text.includes(wort))) return true;
  if (!NUMMERNARTIG.test(wort)) return false;
  const ziffern = nurZiffern(wort);
  if (ziffern.length < 4) return false;
  return texte.some(text => nurZiffern(text).includes(ziffern));
}

// true, wenn jedes Wort des Begriffs in mindestens einem Wert vorkommt.
// Leerer Begriff = alles passt. null/undefined-Werte werden übergangen, damit
// ein abgeschalteter Kundenstamm (Felder null, z. B. atlas) nichts ändert.
export function enthaeltSuchbegriff(werte, begriff) {
  const teile = woerter(begriff);
  if (teile.length === 0) return true;
  const texte = (werte || [])
    .filter(v => v !== null && v !== undefined && v !== '')
    .map(v => String(v).toLowerCase());
  return teile.every(wort => wortPasst(wort, texte));
}

// Ticket: Nummer, Titel, Kunde (Name + Kurzform) und Ansprechpartner. Die
// Kundenfelder liefert der Server an jeder Ticket-Antwort mit (#200).
// zusatzFelder: was eine Stelle darüber hinaus durchsucht (Seitenleiste:
// Beschreibung und Kategorie).
export function ticketPasstZurSuche(ticket, begriff, zusatzFelder = []) {
  if (!ticket) return false;
  return enthaeltSuchbegriff([
    ticket.ticketNumber,
    ticket.title,
    ticket.customerName,
    ticket.customerShortName,
    ticket.contactName,
    ...zusatzFelder
  ], begriff);
}

// Ansprechpartner: Name, beide Nummern, E-Mail.
function ansprechpartnerFelder(kontakt) {
  return [kontakt.name, kontakt.phoneMobile, kontakt.phoneLandline, kontakt.email];
}

export function ansprechpartnerPasstZurSuche(kontakt, begriff) {
  if (!kontakt) return false;
  return enthaeltSuchbegriff(ansprechpartnerFelder(kontakt), begriff);
}

// Kunde: Name, Kurzform, Domänen, Telefonnummern und die Ansprechpartner mit
// Name, Nummern und E-Mail (die Suche der Kundenverwaltung, #205; seit #255
// auch die Nummern und Adressen der Ansprechpartner).
export function kundePasstZurSuche(kunde, begriff) {
  if (!kunde) return false;
  return enthaeltSuchbegriff([
    kunde.name,
    kunde.shortName,
    ...(kunde.domains || []),
    kunde.phone1, kunde.phone2, kunde.phone3,
    ...((kunde.contacts || []).flatMap(ansprechpartnerFelder))
  ], begriff);
}
